/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';
import subCustomerDetailsTemplate from './subcustomer-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function SubCustomerRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.subCustomers', {
            url: '/subCustomers',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'subCustomer.subCustomers'
            },
            ncyBreadcrumb: {
                label: '{"icon": "supervisor_account", "label": "subCustomer.subCustomers"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, subCustomerTableConfig) {
                        return subCustomerTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.subCustomer', {
            url: '/subCustomer',
            module: 'private',
            auth: [types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: subCustomerDetailsTemplate,
                    controllerAs: 'vm',
                    controller: 'SubCustomerDetailsController'
                }
            },
            data: {
                pageTitle: 'subCustomer.subCustomer'
            },
            ncyBreadcrumb: {
                label: '{"icon": "supervisor_account", "label": "subCustomer.subCustomer"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/subcustomer/subcustomer.routes.js